module.exports = __webpack_public_path__ + "first-10-watermark.jpg?f693b7a65360906f5795051b6b989e2e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10-watermark.jpg
// module id = 411
// module chunks = 0